import React from 'react';
import {Button, Form, Modal, Radio} from "semantic-ui-react";
import {useForm} from "react-hook-form";
import {postCourseCategories, putCourseCategories} from "../../../../redux/actions";

export const CourseCategoryForm = ({show, item, onCancel, onSuccess}) => {

    const {register, handleSubmit, formState, setValue, watch} = useForm({
        defaultValues: {
            name: item.name,
            product: item.product
        }
    });

    const product = watch('product');

    React.useEffect(() => {
        register('product');
    }, [register])

    const onSubmit = async data => {

        try {
            const id = parseInt(data.id);
            if (id) {
                await putCourseCategories(data);
            } else {
                await postCourseCategories(data);
            }

            onSuccess();
        } catch (e) {
            alert('error')
        }
    };

    return (
        <Modal open={show} size={'tiny'}>
            <Modal.Header>{item.id ? 'Editar' : 'Criar'} Categoria</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Form id={'form'} onSubmit={handleSubmit(onSubmit)} loading={formState.isSubmitting}>
                        <input type={'hidden'} name={'id'} defaultValue={item.id || ''} ref={register()}/>
                        <Form.Field>
                            <label>Nome</label>
                            <input
                                name={'name'}
                                defaultValue={item.name || ''}
                                ref={register({required: true})}
                                autoFocus
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Tipo</label>
                            <Form.Group inline>
                                <Form.Radio
                                    label='Produto'
                                    name='product'
                                    value={true}
                                    checked={product}
                                    onChange={() => setValue('product', true)}
                                />
                                <Form.Radio
                                    label='Curso'
                                    name='product'
                                    value={false}
                                    checked={!product}
                                    onChange={() => setValue('product', false)}
                                />
                            </Form.Group>
                        </Form.Field>
                    </Form>
                </Modal.Description>
            </Modal.Content>
            <Modal.Actions>
                <Button basic content={'Cancelar'} onClick={onCancel}/>
                <Button
                    positive
                    content="Salvar"
                    form={'form'}
                />
            </Modal.Actions>
        </Modal>
    )
}